import React from 'react';

import styles from './ErrorPage.module.scss';
import config from '../../config/config';
import errorImg from '../../assets/images/warning-exclamation.svg';

const DEFAULT_HEADING_ERROR = {
  msg: 'We are having technical issues loading your page.',
  style: 'errorHeader',
};
const DEFAULT_ERROR_MSG = (
  <div>
    <a
      href={`${config.url}/personal-investing/help/contact/index.html`}
      rel="noopener noreferrer"
      target="_blank"
    >
      Contact us
    </a>{' '}
    (Monday to Friday: 8 a.m to 8 p.m. ET) to speak with a Financial Consultant
    or try again later.
  </div>
);
const DEFAULT_ERROR_IMG = {
  src: errorImg,
  alt: 'Failed to load',
};
const DEFAULT_ERROR_REDIRECT = {
  link: 'usis/rmd-tool',
  text: 'Return to RMD Dashboard',
};

const ErrorPage = ({
  errorMsg = DEFAULT_ERROR_MSG,
  errorHeading = DEFAULT_HEADING_ERROR,
  errorRedirect = DEFAULT_ERROR_REDIRECT,
  errorImg = DEFAULT_ERROR_IMG,
  errorPageBody = null,
}) => {
  return (
    <div className={styles['loading-screen']}>
      <div className={styles['error-container']} id="errorContainer">
        <div className={styles.icon}>
          <img src={errorImg.src} alt={errorImg.alt} />
        </div>
        <div className={styles[errorHeading.style]}>{errorHeading.msg}</div>
        {errorMsg && <div className={styles['error-msg']}>{errorMsg}</div>}
        {errorPageBody}
        <a
          className={`college-branded-link ${styles['retry-link']}`}
          rel="noopener noreferrer"
          href={`${config.url}/${errorRedirect.link}`}
        >
          {errorRedirect.text}
        </a>
      </div>
    </div>
  );
};

export default ErrorPage;
